"use client";

import type { ReactNode } from "react";

/** Renders the site footer (the cream footer on every page). */
export function FooterFrame({ cream }: { children?: ReactNode; cream: ReactNode }) {
  return <>{cream}</>;
}
